import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "offcanvas-backdrop fade show",
  style: {"opacity":"0.8"},
  role: "status",
  "aria-live": "polite",
  "aria-busy": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<div class=\"loader\"><div class=\"square\" aria-hidden=\"true\"></div><div class=\"square\" aria-hidden=\"true\"></div><div class=\"square last\" aria-hidden=\"true\"></div><div class=\"square clear\" aria-hidden=\"true\"></div><div class=\"square\" aria-hidden=\"true\"></div><div class=\"square last\" aria-hidden=\"true\"></div><div class=\"square clear\" aria-hidden=\"true\"></div><div class=\"square\" aria-hidden=\"true\"></div><div class=\"square last\" aria-hidden=\"true\"></div><div class=\"row loading-text\" style=\"display:block;\"><p class=\"h6 mb-0\">Carregando...</p></div></div>", 1)
  ]))]))
}